(function (root, factory) {
  const api = factory();

  if (typeof module === "object" && module.exports) {
    module.exports = api;
    return;
  }

  api.boot();
})(typeof window !== "undefined" ? window : globalThis, function () {
  const floorCareSectionSelector = ".autumn-sale-2026-floor-care";
  const bundleSectionSelector = ".autumn-sale-2026-bundle-save";
  const mobileBreakpoint = 850;
  const mobileDesignWidth = 750;
  const bundleGap = 20;
  const bundleColumnClass = "autumn-sale-2026-bundle-column";

  function refreshChildSwiper(swiper) {
    if (!swiper || swiper.destroyed) return;

    swiper.update();

    if (swiper.pagination) {
      swiper.pagination.render();
      swiper.pagination.update();
    }
  }

  function refreshGroupSwiper(swiperElement) {
    const swiper = swiperElement && swiperElement.groupSwiperInstance;
    if (!swiper || swiper.destroyed) return;

    swiper.update();
    if (typeof swiper.updateAutoHeight === "function") swiper.updateAutoHeight(0);
  }

  function refreshSwiperLayout(swiperElement, index) {
    const instances = (swiperElement && swiperElement.childSwiperInstances) || [];
    const instance = instances[Number(index) || 0];
    if (!instance || instance.destroyed) return false;

    refreshChildSwiper(instance);
    refreshGroupSwiper(swiperElement);
    return true;
  }

  function scheduleRefresh(swiperElement, index) {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        refreshSwiperLayout(swiperElement, index);
      });
    });
  }

  function enhanceFloorCareSection(section) {
    if (!section || section.dataset.floorCareSwiperEnhanced === "true") return;

    const swiperElement = section.querySelector("p-sale-swiper");
    if (!swiperElement) return;

    section.dataset.floorCareSwiperEnhanced = "true";

    let attempts = 0;
    const refreshInitialGroup = function () {
      if (swiperElement.childSwiperInstances && swiperElement.childSwiperInstances.length) {
        scheduleRefresh(swiperElement, 0);
        return;
      }

      attempts += 1;
      if (attempts < 60) requestAnimationFrame(refreshInitialGroup);
    };

    refreshInitialGroup();

    section.addEventListener("click", function (event) {
      const tab = event.target.closest(".p-sale-swiper-group-name");
      if (!tab) return;
      scheduleRefresh(swiperElement, tab.dataset.index);
    });

    let resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        const activeTab = section.querySelector(".p-sale-swiper-group-name.is-active");
        scheduleRefresh(swiperElement, activeTab ? activeTab.dataset.index : 0);
      }, 260);
    });
  }

  function getBundleMobileGap(viewportWidth) {
    return (bundleGap * viewportWidth) / mobileDesignWidth;
  }

  function getBundleProgressIndex(swiper, itemCount) {
    if (!swiper || itemCount < 1) return 0;

    const index = Number.isFinite(swiper.realIndex)
      ? swiper.realIndex
      : Number.isFinite(swiper.snapIndex)
        ? swiper.snapIndex
        : Number(swiper.activeIndex) || 0;

    return Math.max(0, Math.min(itemCount - 1, index));
  }

  function getBundleProgressCount(swiper, itemCount) {
    if (itemCount < 1) return 0;

    const snapCount = swiper && Array.isArray(swiper.snapGrid) ? swiper.snapGrid.length : 0;
    return Math.max(1, Math.min(itemCount, snapCount || itemCount));
  }

  function updateBundleProgress(section, swiper) {
    const items = section.querySelectorAll(".autumn-sale-2026-bundle-mobile-progress span");
    if (!items.length) return;

    const progressCount = getBundleProgressCount(swiper, items.length);
    const activeIndex = getBundleProgressIndex(swiper, progressCount);
    items.forEach(function (item, index) {
      item.hidden = index >= progressCount;
      item.classList.toggle("is-active", index === activeIndex && index < progressCount);
    });
  }

  function resetBundleSlideStyles(slide) {
    slide.classList.remove("swiper-slide");
    ["width", "height", "margin-top", "margin-right", "order"].forEach(function (property) {
      slide.style.removeProperty(property);
    });
  }

  function restoreBundleSlides(wrapper) {
    if (!wrapper) return [];

    const slides = Array.from(wrapper.querySelectorAll(".p-sale-swiper-children-product-item")).filter(
      function (slide) {
        return !slide.closest(".swiper-slide-duplicate");
      },
    );
    const uniqueSlides = Array.from(new Set(slides));

    uniqueSlides.forEach(function (slide, index) {
      if (!slide.dataset.bundleOriginalIndex) slide.dataset.bundleOriginalIndex = String(index);
    });
    uniqueSlides.sort(function (left, right) {
      return Number(left.dataset.bundleOriginalIndex) - Number(right.dataset.bundleOriginalIndex);
    });
    uniqueSlides.forEach(function (slide) {
      resetBundleSlideStyles(slide);
      wrapper.appendChild(slide);
    });
    wrapper.querySelectorAll("." + bundleColumnClass).forEach(function (column) {
      column.remove();
    });

    return uniqueSlides;
  }

  function createBundleColumns(wrapper, slides) {
    const columns = [];

    for (let index = 0; index < slides.length; index += 2) {
      const column = wrapper.ownerDocument.createElement("div");
      column.className = bundleColumnClass + " swiper-slide";
      column.appendChild(slides[index]);
      if (slides[index + 1]) column.appendChild(slides[index + 1]);
      wrapper.appendChild(column);
      columns.push(column);
    }

    return columns;
  }

  function configureBundleMobileSwiper(section, swiperElement) {
    if (window.innerWidth > mobileBreakpoint || typeof Swiper === "undefined") return false;

    const container = swiperElement.querySelector(".p-sale-swiper-children-container");
    const wrapper = container && container.querySelector(".p-sale-swiper-children-wrapper");
    if (!container || !wrapper) return false;

    const current = swiperElement.childSwiperInstances && swiperElement.childSwiperInstances[0];
    if (current && !current.destroyed && current.autumnBundleColumns === true) {
      refreshChildSwiper(current);
      updateBundleProgress(section, current);
      return true;
    }

    if (current && !current.destroyed) current.destroy(true, true);

    const slides = restoreBundleSlides(wrapper);
    if (!slides.length) return false;
    const columns = createBundleColumns(wrapper, slides);

    container.classList.add("swiper-container");
    wrapper.classList.add("swiper-wrapper");

    const instance = new Swiper(container, {
      slidesPerView: 2,
      slidesPerGroup: 1,
      spaceBetween: getBundleMobileGap(window.innerWidth),
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
      loop: false,
      rewind: false,
      allowTouchMove: true,
      watchOverflow: false,
      observer: true,
      observeParents: true,
      on: {
        init: function () {
          updateBundleProgress(section, this);
        },
        slideChange: function () {
          updateBundleProgress(section, this);
        },
      },
    });

    instance.autumnBundleColumns = true;
    swiperElement.childSwiperInstances[0] = instance;
    updateBundleProgress(section, instance);
    return true;
  }

  function enhanceBundleSection(section) {
    if (!section || section.dataset.bundleSwiperEnhanced === "true") return;

    const swiperElement = section.querySelector("p-sale-swiper");
    if (!swiperElement) return;

    section.dataset.bundleSwiperEnhanced = "true";

    let attempts = 0;
    const prepare = function () {
      const canPatch = typeof swiperElement.initChildSwiper === "function";
      const hasInstance = swiperElement.childSwiperInstances && swiperElement.childSwiperInstances.length;

      if (canPatch && !swiperElement.bundleSwiperInitPatched) {
        const initChildSwiper = swiperElement.initChildSwiper;
        swiperElement.initChildSwiper = function () {
          restoreBundleSlides(this.querySelector(".p-sale-swiper-children-wrapper"));
          const result = initChildSwiper.apply(this, arguments);
          requestAnimationFrame(function () {
            configureBundleMobileSwiper(section, swiperElement);
          });
          return result;
        };
        swiperElement.bundleSwiperInitPatched = true;
      }

      if (canPatch && hasInstance) {
        configureBundleMobileSwiper(section, swiperElement);
        return;
      }

      attempts += 1;
      if (attempts < 120) requestAnimationFrame(prepare);
    };

    prepare();

    let resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        configureBundleMobileSwiper(section, swiperElement);
      }, 320);
    });
  }

  function initialize(rootElement) {
    const scope = rootElement || document;
    const floorCareSections =
      scope.matches && scope.matches(floorCareSectionSelector)
        ? [scope]
        : scope.querySelectorAll(floorCareSectionSelector);
    const bundleSections =
      scope.matches && scope.matches(bundleSectionSelector) ? [scope] : scope.querySelectorAll(bundleSectionSelector);

    floorCareSections.forEach(enhanceFloorCareSection);
    bundleSections.forEach(enhanceBundleSection);
  }

  function boot() {
    document.addEventListener("DOMContentLoaded", function () {
      initialize(document);
    });

    document.addEventListener("shopify:section:load", function (event) {
      initialize(event.target);
    });
  }

  return {
    boot,
    configureBundleMobileSwiper,
    getBundleMobileGap,
    getBundleProgressCount,
    getBundleProgressIndex,
    refreshChildSwiper,
    refreshSwiperLayout,
  };
});
